// extracted by mini-css-extract-plugin
module.exports = {"dd-modal__item":"YUCoUAtOcCW6_DkCnfeeJ"};